// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604170947/js/" + chunkId + "." + {"44":"fc75242b","225":"c2f1e167","481":"23529ffb","486":"1921ccd7","770":"59a17043"}[chunkId] + ".0.532364086523581.chunk.js";
};